var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("ul", { staticClass: "nav nav-tabs", attrs: { role: "tablist" } }, [
      _c("li", { staticClass: "nav-item", attrs: { role: "presentation" } }, [
        _c(
          "a",
          {
            staticClass: "nav-link",
            class: { active: _setup.activeTab === "preview" },
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _setup.setTab("preview")
              },
            },
          },
          [_vm._v("\n                Preview\n            ")]
        ),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "nav-item", attrs: { role: "presentation" } }, [
        _c(
          "a",
          {
            staticClass: "nav-link",
            class: { active: _setup.activeTab === "html" },
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _setup.setTab("html")
              },
            },
          },
          [_vm._v("\n                HTML\n            ")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tab-content" }, [
      _setup.activeTab === "preview"
        ? _c(
            "div",
            { staticClass: "tab-pane active", attrs: { role: "tabpanel" } },
            [
              _c("iframe", {
                ref: "iframeRef",
                staticStyle: {
                  width: "100%",
                  "min-height": "250px",
                  border: "solid #ddd",
                  "border-width": "0 1px 1px 1px",
                },
                attrs: { srcdoc: _setup.iframeHtml },
                on: { load: _setup.updateIframeHeight },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.activeTab === "html"
        ? _c(
            "div",
            { staticClass: "tab-pane active", attrs: { role: "tabpanel" } },
            [
              _c(
                _setup.FormControlTypeCodeEditor,
                _vm._g(
                  _vm._b({}, "FormControlTypeCodeEditor", _vm.$props, false),
                  _vm.$listeners
                )
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }